import JSBI from 'jsbi'

export enum ChainId {
  MUMBAI = 80001,
  MATIC = 137,
  FUJI = 43113,
  AVALANCHE = 43114,
  FANTOM_TESTNET = 4002,
  FANTOM = 250,
  HUOBIECO_TESTNET = 256,
  HUOBIECO = 128,
  REEF = 13939,
  XDAI = 100,
  FUSE = 122,
  OPTIMISM = 10,
  OPTIMISM_TESTNET = 69,
  KUCOIN = 321,
  KUCOIN_TESTNET = 322,
  ETHERLITE = 111,
  ETHEREUM_CLASSIC = 61,
  ETHEREUM_CLASSIC_TESTNET = 62,
  MOONBEAM_TESTNET = 1287,
  CLOVER_TESTNET = 123,
  CELO = 42220,
  ALFAJORES = 44787,
  ARBITRUM_TESTNET = 421611,
  ARBITRUM = 42161,
  FLARE = 14,
  FLARE_TESTNET = 16,
  FUSION = 32659,
  HARMONY = 1666600000,
  OKEX = 66,
  IOTEX = 4689,
  HOO = 70,
  ELAETH = 20,
  MOONRIVER = 1285,
  TELOS = 40,
  CRONOS = 25,
  KAVA = 2222,
  BTTC = 199,
  BTTC_TESTNET = 1029,
  BINANCE_TESTNET = 97,
  BINANCE = 56,
  ROPSTEN = 3,
  ETHEREUM = 1,
  NEON_TESTNET = 245022926,
  NEON_MAINNET = 245022934,
  Q = 35441,
  BITGERT = 32520,
  WANCHAIN = 888,
  METIS = 1088,
  ASTAR = 592,
  ARTHERA_TESTNET = 10243,
  ARTHERA = 10242,
  PULSECHAIN = 369,
  BASE = 8453,
  VELAS = 106,
  LINEA = 59144,
  ROOTSTOCK = 30,
  BOBA = 288,
  BOBA_BNB = 56288,
  CLOVER = 1024,
  AURORA = 1313161554,
  ZKSYNC = 324,
  SCROLL = 534352,
  BLAST = 238,
  OPBNB = 204,
  MOONBEAM = 1284,
  MANTLE = 5000,
  POLYGON_ZKEVM = 1101,
  SONIC = 146,
  BERA = 80094,
  EXPCHAIN_TESTNET = 18880,
  CYTONIC_TESTNET = 52226,
}

// exports for external consumption
export type BigintIsh = JSBI | string | number

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT,
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP,
}

export const MaxUint256 = JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')

export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'
